/**
 * Módulo Diseñador — registro de pestañas (todas con pantalla implementada).
 */
import Configuracion from "@/pages/Configuracion";
import ConfiguracionAliasRedirect from "@/pages/ConfiguracionAliasRedirect";
import {
  CONFIGURACION_DESPACHO_PATH,
  CONFIGURACION_EMISOR_PATH,
  CONFIGURACION_ALIAS_PATH,
} from "@/modules/config/configuracionRoutes";
import CarteraLicencias from "@/pages/CarteraLicencias";
import CatalogoCompradores from "@/pages/CatalogoCompradores";
import UsuariosDistribuidor from "@/pages/UsuariosDistribuidor";
import PanelGeneral from "@/pages/PanelGeneral";
import DesignerToolsHub from "@/pages/disenador/DesignerToolsHub";
import DesignerMasterHub from "@/pages/disenador/DesignerMasterHub";
import DesignerBuyerRequestsPage from "@/pages/disenador/DesignerBuyerRequestsPage";
import DesignerCompradoresLicenciasHub from "@/pages/disenador/DesignerCompradoresLicenciasHub";
import DesignerLicensesHub from "@/pages/disenador/DesignerLicensesHub";
import DesignerModulesHub from "@/pages/disenador/DesignerModulesHub";
import DesignerPlatformHub from "@/pages/disenador/DesignerPlatformHub";
import { buildModuloFromTabs, createModuloTab } from "@/modules/moduloTabRegistry";

function DisenadorModuloInicio() {
  return <DesignerMasterHub />;
}

export const MODULO_DISENADOR_ID = "disenador";

export const MODULO_DISENADOR_CARD = {
  id: MODULO_DISENADOR_ID,
  title: "Módulo Maestro Diseñador",
  description:
    "Emisión comercial, Centro de Licencias BNT y herramientas técnicas de soporte.",
};

const CONTEXT_LABEL = "Módulo Maestro Diseñador";

const DISENADOR_TABS = [
  createModuloTab({
    index: true,
    path: "/",
    label: "Panel General",
    iconKey: "panel",
    end: true,
    testid: "nav-panel-general",
    component: <PanelGeneral />,
  }),
  createModuloTab({
    path: "/disenador/inicio",
    label: "Inicio del módulo",
    iconKey: "panel",
    description: "Compradores/licencias, equipo BNT y herramientas técnicas.",
    testid: "nav-disenador-inicio",
    component: <DisenadorModuloInicio />,
  }),
  createModuloTab({
    path: "/disenador/compradores-licencias",
    label: "Compradores y Licencias",
    iconKey: "catalog",
    description:
      "Hub comercial: compradores, licencias, cartera, solicitudes, prospectos y Centro SaaS.",
    testid: "nav-disenador-compradores-licencias",
    component: <DesignerCompradoresLicenciasHub />,
  }),
  createModuloTab({
    path: "/catalogo-compradores",
    label: "Catálogo de compradores",
    iconKey: "catalog",
    description:
      "Prospectos, trials, activos, vencidos y suspendidos. Distinto de clientes fiscales del Visor.",
    component: <CatalogoCompradores />,
  }),
  createModuloTab({
    path: "/cartera-licencias",
    label: "Cartera de licencias",
    iconKey: "briefcase",
    description: "Tokens emitidos, vigencias, renovación y historial por comprador/equipo.",
    component: <CarteraLicencias />,
  }),
  createModuloTab({
    path: "/usuarios-distribuidor",
    label: "Usuarios Administradores BNT",
    iconKey: "users",
    description:
      "Equipo interno del proveedor BNT: diseñador, soporte, comercial y auditoría. No son compradores ni auxiliares del despacho.",
    component: <UsuariosDistribuidor />,
  }),
  createModuloTab({
    path: "/disenador/solicitudes-compradores",
    label: "Solicitudes de compradores",
    iconKey: "listchecks",
    description:
      "Seguimiento de solicitudes de licencia, renovación y activación de módulos.",
    testid: "nav-disenador-solicitudes",
    component: <DesignerBuyerRequestsPage />,
  }),
  createModuloTab({
    path: "/disenador/licencias",
    label: "Licencias distribuidor y cartera",
    iconKey: "briefcase",
    showInNav: false,
    description: "Gestor de emisión y cartera del modelo distribuidor clásico.",
    testid: "nav-disenador-licencias",
    component: <DesignerLicensesHub />,
  }),
  createModuloTab({
    path: "/disenador/modulos-comprador",
    label: "Módulos contratados (legacy)",
    iconKey: "settings",
    showInNav: false,
    description: "Redirige al Centro de Licencias BNT (/platform).",
    testid: "nav-disenador-modulos",
    component: <DesignerModulesHub />,
  }),
  createModuloTab({
    path: "/disenador/centro-bnt",
    label: "Centro de Licencias BNT (legacy)",
    iconKey: "panel",
    showInNav: false,
    description: "Redirige al Centro de Licencias BNT canónico (/platform).",
    testid: "nav-disenador-centro-bnt",
    component: <DesignerPlatformHub />,
  }),
  createModuloTab({
    path: CONFIGURACION_DESPACHO_PATH,
    label: "Configuración del despacho",
    iconKey: "settings",
    showInNav: false,
    description: "Perfil del titular, usuarios, licencia y limpieza del espacio.",
    component: <Configuracion entryMode="despacho" />,
  }),
  createModuloTab({
    path: CONFIGURACION_EMISOR_PATH,
    label: "Gestor de licencias distribuidor",
    iconKey: "settings",
    description:
      "Emisión e importación de licencias del modelo distribuidor. Usuarios y herramientas técnicas viven fuera de esta pantalla.",
    component: <Configuracion entryMode="emisor" />,
  }),
  createModuloTab({
    path: CONFIGURACION_ALIAS_PATH,
    label: "Gestor de Licencias",
    iconKey: "settings",
    showInNav: false,
    description: "Alias temporal — redirige a la ruta canónica según contexto.",
    component: <ConfiguracionAliasRedirect />,
  }),
  createModuloTab({
    path: "/disenador/herramientas",
    label: "Herramientas del diseñador",
    iconKey: "wrench",
    description: "Robot SAT, monitor de ciclo, administración técnica de datos y diagnóstico (sin duplicar operación Visor).",
    testid: "nav-disenador-herramientas",
    component: <DesignerToolsHub />,
  }),
];

export const MODULO_DISENADOR = (() => {
  const mod = buildModuloFromTabs({
    id: MODULO_DISENADOR_ID,
    card: MODULO_DISENADOR_CARD,
    contextLabel: CONTEXT_LABEL,
    tabs: DISENADOR_TABS,
  });
  mod.getDefaultRoute = () => "/disenador/inicio";
  return mod;
})();

export const getModuloDisenadorNavItems = () => MODULO_DISENADOR.getNavItems();
export const getModuloDisenadorPaths = () => MODULO_DISENADOR.getPaths();
export const getModuloDisenadorDefaultRoute = () => MODULO_DISENADOR.getDefaultRoute();
export const isModuloDisenadorPath = (pathname) => MODULO_DISENADOR.isPathAllowed(pathname);
export const getModuloDisenadorContextLabel = () => MODULO_DISENADOR.getContextLabel();
export const getModuloDisenadorRoutes = () => MODULO_DISENADOR.getRoutes();
